import React from "react";
import DealDetails from "../Components/Ambassador/Deals/DealDetails";

const AmbassadorDealPage: React.FC = () => <DealDetails />;

export default AmbassadorDealPage;
